var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"text":_vm.project.name}}),_c('ProjectDescription',{staticClass:"mb-12",attrs:{"project":_vm.project}}),_c('DownloadProjectResult',{attrs:{"projectName":_vm.project.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }